export const StaticData = 'StaticData/';

//contact details
export const GetProvinces = StaticData +'GetProvinces';
export const GetCitites = StaticData + 'GetCities';
export const GetSuburbs = StaticData + 'GetSuburbs';
export const GetMunicipalities = StaticData + 'GetMunicipalities';
export const GetNationalities = StaticData + 'GetNationalities';

//BEE Credentials
export const GetClassifications = StaticData + 'GetClassifications';
export const GetDTISectorCodes = StaticData + 'GetDTISectorCodes';
export const GetEAPSectoralSectors = StaticData + 'GetEAPSectoralSectors';
export const GetBeeScorecardType = StaticData + 'GetBeeScorecardTypes';
export const GetAllScorecardTypes = StaticData + 'GetAllScorecardTypes';
export const GetEESectoralTargetYears = StaticData + 'GetEESectoralTargetYears';
export const GetApplicableEapYears = StaticData + 'GetApplicableEapYears';

//Additional Company Information
export const GetIndustries = StaticData + 'GetIndustries';
export const GetLocations = StaticData + 'GetLocations';

//Company Statistics
export const GetRatings = StaticData + 'GetRatings';
export const GetTurnoverList = StaticData + 'GetTurnoverList';
export const GetNumberOfEmployeesList = StaticData + 'GetNumberOfEmployeesList';

export const GetAutomatedNotificationTypes = StaticData + "AutomatedNotificationTypes";
export const GetAutomatedNotificationTypeAvailableStatuses = StaticData + "AutomatedNotificationTypeAvailableStatuses";

//Verification
export const GetServicesRequired = StaticData + 'GetServicesRequired';
export const GetBBBEECodes = StaticData + 'GetBBBEECodes';
export const GetSectorCodes = StaticData + 'GetSectorCodes';
export const GetScorecardTypeCategories = StaticData + 'GetScorecardTypeCategories';
export const GetOwnershipStructureElements = StaticData + 'GetOwnershipStructureElements';
export const GetServiceRequiredCodeMatrix = StaticData + 'GetServiceRequiredCodeMatrix';
export const GetScorecardAllowedElements = StaticData + 'GetScorecardAllowedElements';

export const GetApplicableBEEScorecardTypes = StaticData + 'GetApplicableBEEScorecardTypes';
export const GetScorecardAndUserAllowedDataPages = StaticData + 'GetScorecardAndUserAllowedDataPages';
export const GetElementsWithDataPages = StaticData + 'GetElementsWithDataPages';

//Employment Equity Plan
export const GetDeviationReasons = StaticData + 'GetDeviationReasons';
export const GetBargainingCouncils = StaticData + 'GetBargainingCouncils'